// Database Safety Guard - ONLY allow production or sandbox
import { DATABASE } from '../Config/firebase';

const ALLOWED_PROJECTS = ['fidduxai-rowy', 'fiddux-sandbox-dev'];

export const validateDatabase = () => {
  const projectId = DATABASE.app.options.projectId;

  if (!ALLOWED_PROJECTS.includes(projectId)) {
    console.error('🚨 CRITICAL ERROR: Wrong database detected!');
    console.error('Expected: fidduxai-rowy or fiddux-sandbox-dev');
    console.error('Got:', projectId);
    throw new Error(`CRITICAL: Wrong database! Expected fidduxai-rowy or fiddux-sandbox-dev, got ${projectId}`);
  }

  return true;
};

// Auto-validate on import
validateDatabase();
